import styled from 'styled-components'

export const Box = styled.div`
  overflow: visible;
  position: relative;
  flex: 1;
  padding: 0;
`
